"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaPurchaseOrderApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaPurchaseOrderApiClient extends BaseApiClient_1.BaseApiClient {
    async retrievePurchaseOrders(queryParams) {
        const path = `/v1.1/purchaseorders`;
        return await this.request("get", path, queryParams, undefined);
    }
    async editPurchaseOrder(postPurchaseOrderDto) {
        const path = `/v1.1/purchaseorders`;
        return await this.request("post", path, undefined, postPurchaseOrderDto);
    }
    async retrievePurchaseOrder(purchaseOrderId) {
        const path = `/v1.1/purchaseorders/${purchaseOrderId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async putPurchaseOrderOtherCosts(purchaseOrderId, putPurchaseOrderOtherCostsDto) {
        const path = `/v1.1/purchaseorders/${purchaseOrderId || ""}/othercosts`;
        return await this.request("put", path, undefined, putPurchaseOrderOtherCostsDto);
    }
    async postToVendorMessage(purchaseOrderId, queryParams) {
        const path = `/v1.1/purchaseorders/${purchaseOrderId || ""}/vendormessages`;
        return await this.request("post", path, queryParams, undefined);
    }
    async createPurchaseOrder(createPurchaseOrderDto) {
        const path = `/v1/purchaseorder`;
        return await this.request("put", path, undefined, createPurchaseOrderDto);
    }
    async authorizePurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/authorize`;
        return await this.request("post", path, queryParams, undefined);
    }
    async cancelPurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/cancel`;
        return await this.request("post", path, queryParams, undefined);
    }
    async confirmPurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/confirm`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrieveFormatTypes() {
        const path = `/v1/purchaseorders/formats`;
        return await this.request("get", path, undefined, undefined);
    }
    async deleteHold(queryParams) {
        const path = `/v1/purchaseorders/holds`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async retrieveHolds(queryParams) {
        const path = `/v1/purchaseorders/holds`;
        return await this.request("get", path, queryParams, undefined);
    }
    async editHold(holdDtos) {
        const path = `/v1/purchaseorders/holds`;
        return await this.request("post", path, undefined, holdDtos);
    }
    async createHold(holdDtos) {
        const path = `/v1/purchaseorders/holds`;
        return await this.request("put", path, undefined, holdDtos);
    }
    async cancelPurchaseOrderItems(purchaseOrderId, queryParams) {
        const path = `/v1/purchaseorders/items/cancel/${purchaseOrderId || ""}`;
        return await this.request("post", path, queryParams, undefined);
    }
    async updatePurchaseOrderItems(editPurchaseOrderItems, purchaseOrderId) {
        const path = `/v1/purchaseorders/items/${purchaseOrderId || ""}`;
        return await this.request("post", path, undefined, editPurchaseOrderItems);
    }
    async addPurchaseOrderItems(addPurchaseOrderItems, purchaseOrderId) {
        const path = `/v1/purchaseorders/items/${purchaseOrderId || ""}`;
        return await this.request("put", path, undefined, addPurchaseOrderItems);
    }
    async deleteMilestones(queryParams) {
        const path = `/v1/purchaseorders/milestones`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async retrieveMilestones() {
        const path = `/v1/purchaseorders/milestones`;
        return await this.request("get", path, undefined, undefined);
    }
    async createOrUpdateMilestones(milestoneDtos) {
        const path = `/v1/purchaseorders/milestones`;
        return await this.request("post", path, undefined, milestoneDtos);
    }
    async reauthorizePurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/reauthorize`;
        return await this.request("post", path, queryParams, undefined);
    }
    async receivePurchaseOrders(receiveDto) {
        const path = `/v1/purchaseorders/receive`;
        return await this.request("post", path, undefined, receiveDto);
    }
    async removePurchaseOrderItems(purchaseOrderId, queryParams) {
        const path = `/v1/purchaseorders/removeitems/${purchaseOrderId || ""}`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async restoreCancelledPurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/restore`;
        return await this.request("post", path, queryParams, undefined);
    }
    async voidPurchaseOrders(queryParams) {
        const path = `/v1/purchaseorders/void`;
        return await this.request("post", path, queryParams, undefined);
    }
    async voidPurchaseOrderItems(purchaseOrderId, queryParams) {
        const path = `/v1/purchaseorders/voiditems/${purchaseOrderId || ""}`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrieveAPurchaseOrdersMilestones(purchaseOrderId) {
        const path = `/v1/purchaseorders/${purchaseOrderId || ""}/milestones`;
        return await this.request("get", path, undefined, undefined);
    }
    async createOrUpdatePurchaseOrderMilestones(purchaseOrderMilestoneDtos, purchaseOrderId) {
        const path = `/v1/purchaseorders/${purchaseOrderId || ""}/milestones`;
        return await this.request("post", path, undefined, purchaseOrderMilestoneDtos);
    }
    async removeASpecificPurchaseOrdersMilestone(milestoneId, purchaseOrderId) {
        const path = `/v1/purchaseorders/${purchaseOrderId || ""}/milestones/${milestoneId || ""}`;
        return await this.request("delete", path, undefined, undefined);
    }
    async retrieveASpecificPurchaseOrdersMilestone(milestoneId, purchaseOrderId) {
        const path = `/v1/purchaseorders/${purchaseOrderId || ""}/milestones/${milestoneId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
}
exports.SkubanaPurchaseOrderApiClient = SkubanaPurchaseOrderApiClient;
